import { ArrayUtil, FormatUtil } from 'helper-util';
import { getPermissionsFromStorage } from '../services/clientConfigurationService';
import { getStringFromStorage } from '../services/storageService';
import { activeClientConfig, isMultiTenants } from '../services/authService';

export const checkFeaturePermission = (permission: string) => {
  const permissionList = getPermissionsFromStorage();
  if (permissionList) {
    let isPermissionAvailable = permissionList.includes(permission);
    const permissionSplitArr = permission.split('_');
    // After config changes either READ or WRITE permissions (Read + Write) are available in token
    if (!isPermissionAvailable && permissionSplitArr[0] === 'R') {
      permissionSplitArr.shift(); // Omit 1st word which is READ
      isPermissionAvailable = permissionList.includes(`RW_${permissionSplitArr.join('_')}`);
    }
    return isPermissionAvailable;
  }
};

export const flattenObject = (parentKey, data) => {
  const lineItem = {};
  if (data && data.constructor === Object) {
    const keys = Object.keys(data);
    keys.forEach((item) => {
      lineItem[`${parentKey}${FormatUtil.text.toTitleCase(item)}`] = data[item];
    });
    return lineItem;
  }
  return null;
};

export const flattenRow = (item) => {
  const itemKey = Object.keys(item);
  let newItem = item;
  itemKey.forEach((key) => {
    const splittedValue = flattenObject(key, item[key]);
    if (splittedValue) newItem = Object.assign(newItem, splittedValue);
  });
  return newItem;
};

export const getThemeFromLs = () => {
  const defaultTheme = 'dark';
  return localStorage.getItem('theme') || defaultTheme;
};

export const checkRouteArrayPermissions = (routePaths) => {
  const permissionList = getPermissionsFromStorage();
  if (permissionList && !ArrayUtil.isEmpty(routePaths)) {
    return routePaths.some((routePath) => {
      if (routePath && routePath.permission && routePath.permission.length > 0) {
        const pageLevelPermissions = routePath.permission;
        return pageLevelPermissions.some((el) => permissionList.includes(el));
      }
      return false;
    });
  } else {
    return false;
  }
};

export const checkRoutePermission = (obj) => {
  const permissionList = getPermissionsFromStorage() || [];
  const currentClientConfig = getStringFromStorage(activeClientConfig);
  const isMultiTenantAvailable = getStringFromStorage(isMultiTenants);
  if (obj && obj.permission && obj.permission.length > 0) {
    const isPermissionFound = obj.permission.some((el) => permissionList.includes(el));
    if (obj.hasOwnProperty('configSpecific')) {
      return obj.configSpecific.includes(currentClientConfig) ? isPermissionFound : false;
    }
    if (obj.hasOwnProperty('notApplicableForMultiTenants')) {
      return obj.notApplicableForMultiTenants && isMultiTenantAvailable === 'true'
        ? false
        : isPermissionFound;
    }
    return isPermissionFound;
  }
  return true;
};

export const isValidFile = (filename: string) => {
  const validExtension = ['csv'];
  const splittedFilename = filename.split('.');
  return splittedFilename.length === 2 && validExtension.includes(splittedFilename[1]);
};
